import v from './Variables';

function forms() {
  let styles = `
    input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="password"] {
      background: ${v.colors.light};
      border: 1px solid ${v.colors.border};
      padding: 0 8px;
      line-height: 35px;
      font-size: 14px;
      color: ${v.colors.dark};
      display: inline-block;
    }

    button[type="submit"] {
      padding: 1px 15px 0 15px;
      font-size: 14px;
      margin: 0;
      border: none;
      line-height: 36px;
      color: ${v.colors.light};
      background: ${v.colors.dark222}
    }

    .error {
      position: absolute;
      right: 8px;
      top: 101%;
      background: ${v.colors.ctaAlt};
      color: #fff;
      font-size: 12px;
      padding: 4px 8px;
      white-space: nowrap;
    }
     `;

  return styles;
}

export default forms;
